export enum BodyDataHooks {
  Main = 'daily-agenda-body',
  LoadMoreButton = 'daily-agenda-load-more-button',
  LoadMoreSpinner = 'daily-agenda-load-more-spinner',
}
